import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const AuthGuard = () => {
	const router: Router = inject(Router);

	const authString = localStorage.getItem('loginAuth');
	if (authString) {
		const auth = JSON.parse(authString);
		if (auth && auth.token) {
			return true;
		}
	}
	router.navigate(['/login']);
	return false;
};
